import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { clsx } from 'clsx';

export interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface PageBreadcrumbProps {
    items: BreadcrumbItem[];
    className?: string;
}

export const PageBreadcrumb: React.FC<PageBreadcrumbProps> = ({ items, className }) => {
    if (items.length < 2) return null;

    return (
        <nav aria-label="Breadcrumb" className={clsx('flex items-center gap-1 text-sm text-muted-foreground', className)}>
            {items.map((item, index) => {
                const isLast = index === items.length - 1;
                return (
                    <React.Fragment key={`${item.label}-${index}`}>
                        {index > 0 && (
                            <ChevronRight className="w-3.5 h-3.5 shrink-0 text-muted-foreground/60" aria-hidden="true" />
                        )}
                        {isLast || !item.href ? (
                            <span
                                className={clsx(isLast && 'text-foreground font-medium truncate max-w-[12rem]')}
                                aria-current={isLast ? 'page' : undefined}
                            >
                                {item.label}
                            </span>
                        ) : (
                            <Link
                                to={item.href}
                                className="hover:text-primary transition-colors truncate max-w-[10rem]"
                            >
                                {item.label}
                            </Link>
                        )}
                    </React.Fragment>
                );
            })}
        </nav>
    );
};
